import React from 'react';
import styles from './Style.module.scss';
import cx from 'classnames';
import ContactDetailsSlideview from "../../Contacts/ContactDetails/ContactDetailsSlideview.jsx"

import Tooltip from "src/components/tooltip";
import _ from 'lodash';

class EmailTagView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Selectedcontact:null,
    }

    this.showContactsView = this.showContactsView.bind(this);
    this._handleRemoveTag = this._handleRemoveTag.bind(this);
  }

  _handleRemoveTag(){
    if(this.props.onRemove){
      this.props.onRemove(this.props.option.value);
    }
  }

  showContactsView(recipientContact){
    this.setState({
      selectedContact:recipientContact
    })
  }

  render() {
    var options = this.props.option;
    var value = {};
    var validOption = false;
    var dnd = "";
    if (!Array.isArray(options)) {
      options = [options];
    }

    options.forEach(option => {
       value = option.value;
  
       validOption = option.valid;
       dnd = value ? value.doNotDisturb : false;
    })

    return (
      <div>
      <div className={cx(styles.tag, { [styles.error]: !validOption }, {[styles.dnd]: dnd})}>
        {this.renderOption(value)}

        {
          !_.get(this.props,"hideRemoveIcon",false) && <span className={styles.remove} onClick={this._handleRemoveTag}>
          <i className='paperflite-close' aria-hidden="true"></i>
        </span>
        }
        
      </div>
      <ContactDetailsSlideview onClose={()=>this.setState({selectedContact:null})} selectedContact={this.state.selectedContact} />
      </div>
    );
  }

  renderOption(tag){
    if(tag.entityType == 'contact'){
      return this.renderContact(tag);
    }else if(tag.entityType == 'contact_list'){
      return this.renderContactList(tag);
    }else{
      return this.renderDefault(tag);
    }
  }

  renderContact(contact){
    return (
      <span className={styles.value}>
        <i className="paperflite-user-settings" aria-hidden="true"></i>
        <Tooltip content={contact.doNotDisturb ? "This contact has enabled DND" : ""}>  
        <a data-for="dndtooltip" data-tip={contact.doNotDisturb ? "This contact has enabled DND" : ""} data-class={styles.dndToolTip} onClick={()=>this.showContactsView(contact)} className={styles.link}>
          {this.renderName(contact)}
        </a>
        </Tooltip>
      </span>
    );
  }

  renderContactList(contactList){
    return (
      <span className={styles.value}>
        <i className="paperflite-group" aria-hidden="true"></i>
        <a href={`${window.location.origin}/settings/contact_list/${contactList.id}`} className={styles.link} target='_blank'>
          {contactList.name}
        </a>
      </span>
    );
  }

  renderName(contact){
    return `${contact.firstName || ''}${contact.lastName && ` ${contact.lastName}` || ''}`
  }

  renderDefault(tag){
    return (
      <span className={cx(styles.value)}>
        <i className="paperflite-mail" aria-hidden="true"></i>
        {tag}
      </span>
    );
  }

}

export default EmailTagView;